"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTextGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Typography_1 = require("../Typography");
var InputTextGroup = function (_a) {
    var label = _a.label, helpText = _a.helpText, dataTestId = _a["data-testid"];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-flex-col squid-gap-component-input-text-group-space-base squid-justify-center squid-pt-0.5" }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "h6", strong: false, size: "base", className: "squid-text-alias-color-text-weak", "data-testid": "".concat(dataTestId, "Label") }, { children: label })), helpText && ((0, jsx_runtime_1.jsx)(Typography_1.Body, __assign({ as: "p", size: "sm", variant: "base", className: "squid-text-alias-color-text-weakest", "data-testid": "".concat(dataTestId, "HelpText") }, { children: helpText })))] })));
};
exports.InputTextGroup = InputTextGroup;
